/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular.module('com.vmware.vsphere.client.networkLibUi').
      service('physicalAdapterDetailsViewService', physicalAdapterDetailsViewService);

   physicalAdapterDetailsViewService.$inject = [
      'i18nService',
      'vxPropertyViewService',
      'networkUtil'
   ];

   function physicalAdapterDetailsViewService (i18nService, propertyViewService, networkUtil) {
      return {
         build: build,
         buildOnlyProperties: buildOnlyProperties,
         buildOnlyCdp: buildOnlyCdp,
         buildOnlyLldp: buildOnlyLldp
      };

      function build (pnicDetailsItem) {
         if (pnicDetailsItem !== null) {
            var builder = propertyViewService.createPropertyViewBuilder();
            buildPropertiesCategoryInternal(builder, pnicDetailsItem);
            buildCdpCategoryInternal(builder, pnicDetailsItem);
            buildLldpCategoryInternal(builder, pnicDetailsItem);

            // Add 'All' tab
            builder
               .category('all', 0)
               .title(i18nService.getString(
                  'H5NetworkUi', 'PhysicalAdapterDetailsView.allTabTitle'))
               .cloneAndAddBuilder(builder.getSection('properties', 'general'))
               .cloneAndAddBuilder(builder.getSection('properties', 'status'))
               .cloneAndAddBuilder(builder.getSection('properties', 'networkIoControl'))
               .cloneAndAddBuilder(builder.getSection('properties', 'sriov'))
               .cloneAndAddBuilder(builder.getSection('cdp', 'cdpSection'))
               .cloneAndAddBuilder(builder.getSection('cdp', 'cdpCapabilitySection'))
               .cloneAndAddBuilder(builder.getSection('lldp', 'lldpSection'))
               .cloneAndAddBuilder(builder.getSection('lldp', 'lldpCapabilitySection'));

            return builder.build();
         }
         return {};
      }

      function buildOnlyProperties(pnicDetailsItem) {
         var builder = propertyViewService.createPropertyViewBuilder();
         buildPropertiesCategoryInternal(builder, pnicDetailsItem);

         builder.getCategory("properties").title(null);

         return builder.build();
      }

      function buildOnlyCdp(pnicDetailsItem) {
         var builder = propertyViewService.createPropertyViewBuilder();
         buildCdpCategoryInternal(builder, pnicDetailsItem);

         builder.getCategory("cdp").title(null);

         return builder.build();
      }

      function buildOnlyLldp(pnicDetailsItem) {
         var builder = propertyViewService.createPropertyViewBuilder();
         buildLldpCategoryInternal(builder, pnicDetailsItem);

         builder.getCategory("lldp").title(null);

         return builder.build();
      }

      function buildPropertiesCategoryInternal(builder, pnicDetailsItem) {
         var categoryBuilder = builder
            .category("properties")
            .title(networkUtil.getString('PnicView.adapterDetails'));

         buildGeneralSection(categoryBuilder, pnicDetailsItem);
         buildStatusSection(categoryBuilder, pnicDetailsItem);
         buildSriovSection(categoryBuilder, pnicDetailsItem);
      }

      function buildGeneralSection(categoryBuilder, pnicDetailsItem) {
         categoryBuilder
            .section("general")
            .property(
               networkUtil.getString('PnicView.adapter'),
               pnicDetailsItem.adapterName)
            .property(
               networkUtil.getString('PnicView.name'),
               pnicDetailsItem.deviceName)
            .property(
               networkUtil.getString('PnicView.location'),
               pnicDetailsItem.location)
            .property(
               networkUtil.getString('PnicView.driver'),
               pnicDetailsItem.driverName);
      }

      function buildStatusSection(categoryBuilder, pnicDetailsItem) {
         function getPnicActualSpeedValue() {
            var actualSpeedValue;
            if (!pnicDetailsItem.actualSpeed) {
               actualSpeedValue = networkUtil.getString('PnicView.down');
            } else if (pnicDetailsItem.isActualSpeedFullDuplex) {
               actualSpeedValue = networkUtil.getString(
                  'PnicView.mbFullDuplex', pnicDetailsItem.actualSpeed);
            } else {
               actualSpeedValue = networkUtil.getString(
                  'PnicView.mbHalfDuplex', pnicDetailsItem.actualSpeed);
            }
            return actualSpeedValue;
         }

         function getConfiguredSpeedValue() {
            var configuredSpeedValue;
            if (!pnicDetailsItem.configuredSpeed) {
               configuredSpeedValue = networkUtil.getString('PnicView.autonegotiate');
            } else if (pnicDetailsItem.isConfiguredSpeedFullDuplex) {
               configuredSpeedValue = networkUtil.getString('PnicView.mbFullDuplex', pnicDetailsItem.configuredSpeed);
            } else {
               configuredSpeedValue = networkUtil.getString('PnicView.mbHalfDuplex', pnicDetailsItem.configuredSpeed);
            }
            return configuredSpeedValue;
         }

         function getNetworks() {
            return (pnicDetailsItem.networkHints && pnicDetailsItem.networkHints.length) ?
               pnicDetailsItem.networkHints : networkUtil.getString('NetworkUtil.NoNetworks');
         }

         categoryBuilder
            .section("status")
            .title(networkUtil.getString('PnicView.status'))

            .property(
               networkUtil.getString('PnicView.statusLabel'),
               pnicDetailsItem.isConnected
                  ? networkUtil.getString('PnicView.connected')
                  : networkUtil.getString('PnicView.disconnected'))
            .property(
               networkUtil.getString('PnicView.actualSpeed'),
               getPnicActualSpeedValue())
            .property(
               networkUtil.getString('PnicView.configSpeed'),
               getConfiguredSpeedValue())
            .property(
               networkUtil.getString('PnicView.networks'),
               getNetworks());

         if (pnicDetailsItem.resourcePoolSchedulerAllowed !== null) {
            var sectionBuilder =
               categoryBuilder
                  .section("networkIoControl")
                  .title(networkUtil.getString('PnicView.netIorm'));
            sectionBuilder
               .property(
                  networkUtil.getString('PnicView.status'),
                  pnicDetailsItem.resourcePoolSchedulerAllowed
                     ? networkUtil.getString('PnicView.netIorm.allowed')
                     : networkUtil.getString('PnicView.netIorm.notAllowed')
               );

            _.forEach(pnicDetailsItem.resourcePoolSchedulerDisallowedReasons,
               function (reason) {
                  sectionBuilder.info(reason);
               });
         }
      }

      function buildSriovSection(categoryBuilder, pnicDetailsItem) {
         function getVirtualFunctions() {
            if (pnicDetailsItem.sriovInfo.numVirtualFunctionsRequested ===
                  pnicDetailsItem.sriovInfo.numVirtualFunction) {
               return pnicDetailsItem.sriovInfo.numVirtualFunction;
            }

            return networkUtil.getString('Sriov.vf.mixedFormat',
                        pnicDetailsItem.sriovInfo.numVirtualFunctionsRequested,
                        pnicDetailsItem.sriovInfo.numVirtualFunction);
         }

         if (pnicDetailsItem.sriovInfo && pnicDetailsItem.sriovInfo.sriovCapable) {
            if (pnicDetailsItem.sriovInfo.sriovEnabled) {
               categoryBuilder
                     .section("sriov")
                     .title(networkUtil.getString('Sriov.title'))
                     .property(networkUtil.getString('Sriov.status'),
                           networkUtil.getString('Sriov.status.enabled'))
                     .property(networkUtil.getString('Sriov.virtualFunctionsCount'),
                           getVirtualFunctions());
            } else {
               categoryBuilder
                     .section("sriov")
                     .title(networkUtil.getString('Sriov.title'))
                     .property(networkUtil.getString('Sriov.status'),
                           networkUtil.getString('Sriov.status.disabled'));
            }
         } else {
            categoryBuilder
                  .section("sriov")
                  .title(networkUtil.getString('Sriov.title'))
                  .property(networkUtil.getString('Sriov.status'),
                        networkUtil.getString('Sriov.status.notSupported'));
         }
      }

      function buildCdpCategoryInternal(builder, pnicDetailsItem) {
         var categoryBuilder = builder
            .category("cdp")
            .title(networkUtil.getString('CdpDetailsView.category'));

         var cdpSectionBuilder = categoryBuilder
            .section("cdpSection")
            .title(networkUtil.getString('CdpDetailsView.title'));

         if (!pnicDetailsItem.areNetworkHintsRetrieved) {
            cdpSectionBuilder.info(networkUtil.getString('CdpDetailsView.notAccessible'));

         } else {

            if (pnicDetailsItem.cdpInfo === null) {

               cdpSectionBuilder.info(networkUtil.getString('CdpDetailsView.notAvailable'));
            } else {
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.version'),
                  pnicDetailsItem.cdpInfo.version);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.timeout'),
                  pnicDetailsItem.cdpInfo.timeout);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.ttl'),
                  pnicDetailsItem.cdpInfo.ttl);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.samples'),
                  pnicDetailsItem.cdpInfo.samples);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.deviceId'),
                  pnicDetailsItem.cdpInfo.devId);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.ipAddress'),
                  pnicDetailsItem.cdpInfo.address);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.portId'),
                  pnicDetailsItem.cdpInfo.portId);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.softwareVersion'),
                  pnicDetailsItem.cdpInfo.softwareVersion);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.hardwarePlatform'),
                  pnicDetailsItem.cdpInfo.hardwarePlatform);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.ipPrefix'),
                  pnicDetailsItem.cdpInfo.ipPrefix);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.ipPrefixLength'),
                  pnicDetailsItem.cdpInfo.ipPrefixLen);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.vlan'),
                  pnicDetailsItem.cdpInfo.vlan);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.fullDuplex'),
                  pnicDetailsItem.cdpInfo.fullDuplex);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.mtu'),
                  pnicDetailsItem.cdpInfo.mtu);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.systemName'),
                  pnicDetailsItem.cdpInfo.systemName);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.systemOid'),
                  pnicDetailsItem.cdpInfo.systemOID);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.managementAddress'),
                  pnicDetailsItem.cdpInfo.mgmtAddr);
               cdpSectionBuilder.property(networkUtil.getString('CdpDetailsView.location'),
                  pnicDetailsItem.cdpInfo.location);

               var cdpCapabilitySectionBuilder =
                  categoryBuilder
                     .section("cdpCapabilitySection")
                     .title(networkUtil.getString('CdpDetailsView.deviceCapability'));

               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.router'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.router);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.transBridge'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.transparentBridge);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.srcRouteBridge'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.sourceRouteBridge);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.networkSwitch'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.networkSwitch);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.host'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.host);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.igmp'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.igmpEnabled);
               cdpCapabilitySectionBuilder.property(
                  networkUtil.getString('CdpDetailsView.repeater'),
                  pnicDetailsItem.cdpInfo.deviceCapabilities.repeater);
            }
         }
      }

      function buildLldpCategoryInternal(builder, pnicDetailsItem) {

         var categoryBuilder = builder
            .category("lldp")
            .title(networkUtil.getString('LldpDetailsView.category'));

         var lldpSectionBuilder = categoryBuilder
            .section("lldpSection")
            .title(networkUtil.getString('LldpDetailsView.title'));

         if (!pnicDetailsItem.areNetworkHintsRetrieved) {
            lldpSectionBuilder.info(
               networkUtil.getString('LldpDetailsView.notAccessible'));
         } else {
            if (pnicDetailsItem.lldpInfo === null) {
               lldpSectionBuilder.info(
                  networkUtil.getString('LldpDetailsView.notAvailable'));
            } else {

               lldpSectionBuilder.property(networkUtil.getString('LldpDetailsView.chassisId'),
                  pnicDetailsItem.lldpInfo.chassisId);
               lldpSectionBuilder.property(networkUtil.getString('LldpDetailsView.portId'),
                  pnicDetailsItem.lldpInfo.portId);
               lldpSectionBuilder.property(networkUtil.getString('LldpDetailsView.ttl'),
                  pnicDetailsItem.lldpInfo.ttl);

               _.forEach(pnicDetailsItem.lldpInfo.parameter, function (param) {
                  lldpSectionBuilder.property(param.key,
                     param.value);
               });

               var lldpCapabilitySectionBuilder =
                  categoryBuilder
                     .section("lldpCapabilitySection")
                     .title(networkUtil.getString(
                        'LldpDetailsView.deviceCapability'));

               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.router'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.router);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.transBridge'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.transparentBridge);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.srcRouteBridge'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.sourceRouteBridge);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.networkSwitch'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.networkSwitch);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.host'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.host);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.igmp'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.igmpEnabled);
               lldpCapabilitySectionBuilder.property(
                  networkUtil.getString('LldpDetailsView.repeater'),
                  pnicDetailsItem.lldpInfo.deviceCapabilities.repeater);
            }
         }
      }
   }
}());
